import type { FormTheme } from '@nanoapp/types';

export const PRESET_THEMES: FormTheme[] = [
  {
    id: 'default',
    name: 'Padrão',
    primaryColor: '#6366f1',
    accentColor: '#818cf8',
    backgroundColor: '#ffffff',
    pageBackground: '#f1f5f9',
    textColor: '#1e293b',
    labelColor: '#374151',
    inputBgColor: '#ffffff',
    inputBorderColor: '#d1d5db',
    inputBorderRadius: '0.5rem',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '16px',
    buttonStyle: 'filled',
    buttonBorderRadius: '0.5rem',
    shadow: 'md',
  },
  {
    id: 'dark',
    name: 'Dark',
    primaryColor: '#818cf8',
    accentColor: '#a78bfa',
    backgroundColor: '#1e1e2e',
    pageBackground: '#13131f',
    textColor: '#e2e8f0',
    labelColor: '#cbd5e1',
    inputBgColor: '#2a2a3e',
    inputBorderColor: '#3d3d5c',
    inputBorderRadius: '0.5rem',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '16px',
    buttonStyle: 'filled',
    buttonBorderRadius: '0.5rem',
    shadow: 'lg',
  },
  {
    id: 'minimal',
    name: 'Minimal',
    primaryColor: '#18181b',
    accentColor: '#52525b',
    backgroundColor: '#ffffff',
    pageBackground: '#ffffff',
    textColor: '#18181b',
    labelColor: '#3f3f46',
    inputBgColor: '#fafafa',
    inputBorderColor: '#e4e4e7',
    inputBorderRadius: '0.25rem',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '15px',
    buttonStyle: 'outline',
    buttonBorderRadius: '0.25rem',
    shadow: 'none',
  },
  {
    id: 'soft',
    name: 'Soft',
    primaryColor: '#ec4899',
    accentColor: '#f472b6',
    backgroundColor: '#fff0f6',
    pageBackground: '#fce7f3',
    textColor: '#4a2040',
    labelColor: '#6b3a58',
    inputBgColor: '#ffffff',
    inputBorderColor: '#fbcfe8',
    inputBorderRadius: '1rem',
    fontFamily: "'Georgia', serif",
    fontSize: '16px',
    buttonStyle: 'filled',
    buttonBorderRadius: '2rem',
    shadow: 'sm',
  },
  {
    id: 'corporate',
    name: 'Corporativo',
    primaryColor: '#1d4ed8',
    accentColor: '#3b82f6',
    backgroundColor: '#ffffff',
    pageBackground: '#eff6ff',
    textColor: '#1e3a5f',
    labelColor: '#1e40af',
    inputBgColor: '#ffffff',
    inputBorderColor: '#bfdbfe',
    inputBorderRadius: '0.25rem',
    fontFamily: "'Arial', sans-serif",
    fontSize: '16px',
    buttonStyle: 'filled',
    buttonBorderRadius: '0.25rem',
    shadow: 'sm',
  },
  {
    id: 'nature',
    name: 'Nature',
    primaryColor: '#16a34a',
    accentColor: '#22c55e',
    backgroundColor: '#f0fdf4',
    pageBackground: '#dcfce7',
    textColor: '#14532d',
    labelColor: '#166534',
    inputBgColor: '#ffffff',
    inputBorderColor: '#bbf7d0',
    inputBorderRadius: '0.5rem',
    fontFamily: "'Trebuchet MS', sans-serif",
    fontSize: '16px',
    buttonStyle: 'filled',
    buttonBorderRadius: '0.5rem',
    shadow: 'sm',
  },
];

export const DEFAULT_THEME = PRESET_THEMES[0];
